import $ from 'jquery';

$(document).ready(function () {
  sliderWidget();
});

function sliderWidget() {
  $('.js-slider-widget').each(function () {
    const $section = $(this);
    const $slider = $section.find('.slider-widget-slider');
    const $nextSection = $section.parents('.elementor-element').next();

    //let lastSlideIndex = 0;
    let isScrolling = false;
    //eslint-disable-next-line no-unused-vars
    let wheelLocked = false;

    $slider.slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      vertical: true,
      verticalSwiping: true,
    });

    // Debounce для wheel
    const lockWheel = (time = 600) => {
      wheelLocked = true;
      setTimeout(() => (wheelLocked = false), time);
    };

    $section.on('wheel', { passive: false }, function (e) {
      const deltaY = e.originalEvent.deltaY;
      //check section in viewport
      const sectionTop = $section.offset().top;
      const scrollTop = $(window).scrollTop();
      //check if we scrolling now
      if (isScrolling) return;

      if (deltaY > 0 && sectionTop - 100 <= scrollTop) {
        e.preventDefault();
        lockWheel();
        //check if it's last slide then stay on it or go to next slide
        if (
          $slider.slick('slickCurrentSlide') ===
          $slider.slick('getSlick').slideCount - 1
        ) {
          lockWheel(600);
          animateToSection($nextSection);
          setTimeout(() => {
            $slider.slick('slickGoTo', 0, true);
          }, 1000);
        } else {
          $slider.slick('slickNext');
        }
      }
    });

    const animateToSection = (section) => {
      if (isScrolling) return;

      isScrolling = true;

      $('html, body').animate(
        {
          scrollTop: section.offset().top,
        },
        600,
        'swing',
        function () {
          isScrolling = false;
        }
      );
    };

    //scroll to next/previous section on slide change
    $slider.on('beforeChange', function () {
      //const totalSlides = slick.slideCount;
      isScrolling = false;

      //check direction
      // let goingForward =
      //   currentSlide > lastSlideIndex ||
      //   (lastSlideIndex === totalSlides - 1 && currentSlide === 0);

      //lastSlideIndex = currentSlide;

      //scroll to next section
      // if (
      //   goingForward &&
      //   currentSlide >= totalSlides - 1 &&
      //   !isScrolling &&
      //   $nextSection.length
      // ) {
      //   lockWheel(600);
      //   animateToSection($nextSection);
      // }
    });
  });
}
